<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">URAs</div>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-text>
          <Dialog  :ura="ura" />
        </v-card-text> 

        <v-divider />

        <v-card-actions>
        <v-spacer />
            <v-btn color="blue darken-1" text @click="dialog = false">Sair</v-btn>
        </v-card-actions> 
      </v-card>  
    </v-dialog>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataUras"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn dark color="orangePcm" href="/pabx/cadastro/uras/criar" target="_blank" @click="handleGoToNewUra"
              >Criar Ura</v-btn
            >
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    dark
                    color="bluePcm"
                    target="_blank"
                    v-bind="attrs"
                    v-on="on"
                    @click="openDialog(item)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
              <span>Uso</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/cadastro/uras/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="atualizarButton(item, $event)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de URAs: {{ qtdUras }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import urasStore from '../_store'
import UrasHttpService from '../_services/UrasHttpService'
import Dialog from '../_components/Dialog.vue'

export default {
  components: { ListPagination, Dialog },

  mixins: [pagesHomeMixins],

  data: () => ({
    headers: [
      {
        text: 'URA',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Áudio Principal',
        value: 'audioPrincipal',
        align: 'left',
      },
      {
        text: 'Qtd. Dígitos',
        value: 'quantidadeDigitos',
        align: 'right',
        sortable: false,
      },
      {
        text: 'Loop',
        value: 'quantidadeDeLoops',
        align: 'right',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataUras: [],
    ura: {},
    dialog: false,
  }),
  computed: {
    ...mapGetters('urasHomeModulePABXStore', ['getUras', 'getAudios']),

    numberOfPages() {
      return Math.ceil(this.dataUras.length / this.itemsPerPage)
    },
    qtdUras() {
      return this.dataUras.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'urasHomeModulePABXStore', urasStore)

    await Promise.all([this.listarUras(), this.listarAudios()])

    this.dataUras = [...this.getUras]

    this.getAudios.forEach(audio => {
      this.dataUras.forEach(ura => {
        if (ura.audioPrincipal == audio.audio) {
          ura.audioPrincipal = audio.description
        }
      })
    })
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('urasHomeModulePABXStore', ['listarUras', 'listarAudios', 'listarUraUse']),

    handleGoToNewUra(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewUra = this.$router.resolve({ name: 'Uras/criar' })
        window.open(goToNewUra.href, '_blank')
      } else {
        this.$router.push({ name: 'Uras/criar' })
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`uras/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`uras/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(item, event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`uras/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`uras/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover a URA "${item.description}"?`)
      if (resultado) {
        try {
          await UrasHttpService.deleteUra(item._id)
          this.dataUras = this.dataUras.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
    async openDialog(ura) {
      await this.listarUraUse(ura._id)
      this.ura = ura
      this.dialog = true
    }
  },
}
</script>
